import React, {useState} from "react";
import TextFieldWithValidation from "./TextFieldWithValidation";
import { Box,Typography } from "@mui/material";
import zipcodes from "zipcodes";

const CrewMemberForm = ({ formData, handleInputChange, handleBlur, errors }) => {
    const [location, setLocation] = useState(null);
  
    const handleZipCodeChange = (e) => {
      const { value } = e.target;
      handleInputChange(e); 
  
      // Look up the location based on the zip code
      const locationInfo = zipcodes.lookup(value);
      if (locationInfo) {
        const location = `${locationInfo.city}, ${locationInfo.state}`;
        setLocation(location); 
  
        // Update the form data with the location
        handleInputChange({
          target: {
            name: "location",
            value: location,
          },
        });
      } else {
        setLocation(null); 
        // Clear the location in the form data
        handleInputChange({
          target: {
            name: "location",
            value: "",
          },
        });
      }
    }
    return (
  <>
    <Box className="name-fields">
      <TextFieldWithValidation
        name="firstName"
        label="First Name"
        value={formData.firstName}
        onChange={handleInputChange}
        onBlur={handleBlur}
        error={errors.firstName}
      />
      <TextFieldWithValidation
        name="lastName"
        label="Last Name"
        value={formData.lastName}
        onChange={handleInputChange}
        onBlur={handleBlur}
        error={errors.lastName}
      />
    </Box>
    <Box className="name-fields">
    <TextFieldWithValidation
          name="zipCode"
          label="Zip Code"
          value={formData.zipCode}
          onChange={handleZipCodeChange} 
          onBlur={handleBlur}
          error={errors.zipCode}
        />
        {location && (
          <Typography variant="body2" sx={{ mt: 1 }}>
             {location}
          </Typography>
        )}
      <TextFieldWithValidation
        name="phoneNumber"
        label="Phone Number"
        value={formData.phoneNumber}
        onChange={handleInputChange}
        onBlur={handleBlur}
        error={errors.phoneNumber}
      />
    </Box>
    <TextFieldWithValidation
      name="email"
      label="Email"
      value={formData.email}
      onChange={handleInputChange}
      onBlur={handleBlur}
      error={errors.email}
    />
    <TextFieldWithValidation
      name="age"
      label="Age"
      value={formData.age}
      onChange={handleInputChange}
      onBlur={handleBlur}
      error={errors.age}
    />
    <TextFieldWithValidation
      name="password"
      label="Create Password"
      type="password"
      value={formData.password}
      onChange={handleInputChange}
      onBlur={handleBlur}
      error={errors.password}
    />
    <TextFieldWithValidation
      name="confirmPassword"
      label="Confirm Password"
      type="password"
      value={formData.confirmPassword}
      onChange={handleInputChange}
      onBlur={handleBlur}
      error={errors.confirmPassword}
    />
  </>
);
};
export default CrewMemberForm;
